<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar>
      <ion-row
        ><ion-col>
          <ion-label
            position="stacked"
            style="padding-left: 30px; font-size: x-large"
            >{{heading}}</ion-label
          >
          <br />
          <ion-label
            position="stacked"
            style="font-size: medium; padding-left: 20%"
            >{{additionalText}}</ion-label
          >
        </ion-col>
        <ion-buttons>
          <ion-button (click)="closeModal()" size="large" slot="end">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-row>
    </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <!-- <ion-label position="stacked" style="font-size: x-large"
      >{{heading}}</ion-label
    >
    <br />
    <ion-label position="stacked" style="font-size: medium; padding-left: 20%"
      >{{additionalText}}</ion-label
    > -->
      <ion-row>
        <ion-col
          [ngClass]="{'selected-tab': mediaTypeSelected === 'Videos'}"
          class="ion-col"
        >
          <ion-button class="color" fill="clear" (click)="onTabClick('Videos')">
            <ion-icon name="videocam"></ion-icon>
            <span>Videos</span>
          </ion-button>
        </ion-col>

        <ion-col
          [ngClass]="{'selected-tab': mediaTypeSelected === 'Pictures'}"
          class="ion-col"
        >
          <ion-button
            class="color"
            fill="clear"
            (click)="onTabClick('Pictures')"
          >
            <ion-icon name="images"></ion-icon>
            <span>Pictures</span>
          </ion-button>
        </ion-col>

        <ion-col
          [ngClass]="{'selected-tab': mediaTypeSelected === 'Documents'}"
          class="ion-col"
        >
          <ion-button
            class="color"
            fill="clear"
            (click)="onTabClick('Documents')"
          >
            <ion-icon name="document"></ion-icon>
            <span>Documents</span>
          </ion-button>
        </ion-col>

        <ion-col
          [ngClass]="{'selected-tab': mediaTypeSelected === 'Scenes'}"
          class="ion-col"
        >
          <ion-button class="color" fill="clear" (click)="onTabClick('Scenes')">
            <ion-icon name="copy"></ion-icon>
            <span>Sections</span>
          </ion-button>
        </ion-col>

        <ion-col
          [ngClass]="{'selected-tab': mediaTypeSelected === 'Upload new media'}"
          class="ion-col"
        >
          <ion-button
            class="color"
            fill="clear"
            (click)="onTabClick('Upload new media')"
          >
            <ion-icon name="cloud-upload"></ion-icon>
            <span>Upload new media</span>
          </ion-button>
        </ion-col>
        <ion-col></ion-col>
        <ion-col></ion-col>
      </ion-row>

      <!-- Searching -->
      <ion-grid>
        <ion-row>
          <ion-col size="10">
            <ion-item>
              <ion-label position="stacked"
                >Type to search Content Library
              </ion-label>
              <ion-input
                [(ngModel)]="searchText"
                (keyup.enter)="search()"
              ></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="2">
            <ion-button (click)="search()">
              <ion-label>Search</ion-label>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div *ngIf="mediaTypeSelected == 'Scenes'">
        <div *ngFor="let mediaSelection of sceneMediaSelectionList;">
          <ion-accordion-group #accordionGroup>
            <div
              style="
                /* padding: 20px;
                    padding-top: 0px;
                    padding-bottom: 5px; */
                width: 900px;
              "
            >
              <ion-accordion value="first">
                <ion-item slot="header" color="light">
                  <ion-label>{{mediaSelection.SceneName}}</ion-label>
                </ion-item>
                <div>Media</div>
                <div
                  class="ion-padding"
                  *ngFor="let item of mediaSelection.media;"
                  slot="content"
                >
                  <ion-grid>
                    <ion-row>
                      <ion-col size="1">
                        <ion-checkbox
                          justify="end"
                          [(ngModel)]="item.isChecked"
                        ></ion-checkbox>
                      </ion-col>
                      <ion-col size="4">
                        <img
                          (click)="showContent(item.description,item.Content_GUID)"
                          class="media-thumbnail-img-small border-radius"
                          style="padding: 5px; display: inline-block"
                          (error)="globals.onThumbnailError($event,'blank.jpg')"
                          src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + item?.Content_GUID + '.jpg'}}"
                        />
                      </ion-col>
                      <ion-col size="7">
                        <ion-label
                          style="padding-left: 10px; display: inline-block"
                          >{{item.text}}</ion-label
                        >
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
                <div
                  class="ion-padding"
                  *ngFor="let questionItem of mediaSelection.question;"
                  slot="content"
                >
                  <ion-grid>
                    <ion-row>
                      <ion-col size="1">
                        <ion-checkbox
                          justify="end"
                          [(ngModel)]="questionItem.isChecked"
                        ></ion-checkbox>
                      </ion-col>
                      <ion-col size="10">
                        <ion-label
                          style="padding-left: 10px; display: inline-block"
                          >{{questionItem.text}}</ion-label
                        >
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
              </ion-accordion>
              <br />
            </div>
          </ion-accordion-group>
        </div>
      </div>

      <div *ngIf="mediaTypeSelected == 'Videos'">
        <ion-row>
          <ion-col size="1"> </ion-col>
          <ion-col size="1"> </ion-col>
          <ion-col size="10">
            <ion-item>
              <ion-label>Description</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <div *ngFor="let media of mediaSelectionList;">
          <ion-row>
            <ion-col size="1">
              <ion-checkbox
                justify="end"
                [(ngModel)]="media.isChecked"
              ></ion-checkbox>
            </ion-col>
            <ion-col
              size="1"
              (click)="showContent(media.description,media.Content_GUID)"
            >
              <img
                class="media-thumbnail-img-small border-radius"
                style="display: inline-block"
                (error)="globals.onThumbnailError($event,'blank.jpg')"
                src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + media?.Content_GUID + '.jpg'}}"
              />
            </ion-col>
            <ion-col
              size="10"
              (click)="showContent(media.description,media.Content_GUID)"
            >
              <ion-item>
                <ion-label>{{media.description}}</ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <div *ngIf="mediaTypeSelected == 'Pictures'">
        <ion-row>
          <ion-col size="1"> </ion-col>
          <ion-col size="1"> </ion-col>
          <ion-col size="10">
            <ion-item>
              <ion-label>Description</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <div *ngFor="let media of mediaSelectionList;">
          <ion-row>
            <ion-col size="1">
              <ion-checkbox
                justify="end"
                [(ngModel)]="media.isChecked"
              ></ion-checkbox>
            </ion-col>
            <ion-col
              size="1"
              (click)="showContent(media.description,media.Content_GUID)"
            >
              <img
                class="media-thumbnail-img-small border-radius"
                style="display: inline-block"
                (error)="globals.onThumbnailError($event,'blank.jpg')"
                src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + media?.Content_GUID + '.jpg'}}"
              />
            </ion-col>
            <ion-col
              size="10"
              (click)="showContent(media.description,media.Content_GUID)"
            >
              <ion-item>
                <ion-label>{{media.description}}</ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <div *ngIf="mediaTypeSelected == 'Documents'">
        <ion-row>
          <ion-col size="1"> </ion-col>
          <ion-col size="1"> </ion-col>
          <ion-col size="10">
            <ion-item>
              <ion-label>Description</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <div *ngFor="let media of mediaSelectionList;">
          <ion-row>
            <ion-col size="1">
              <ion-checkbox
                justify="end"
                [(ngModel)]="media.isChecked"
              ></ion-checkbox>
            </ion-col>
            <ion-col
              size="1"
              (click)="showContent(media.description,media.Content_GUID)"
            >
              <img
                class="media-thumbnail-img-small border-radius"
                style="display: inline-block"
                (error)="globals.onThumbnailError($event,'blank.jpg')"
                src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + media?.Content_GUID + '.jpg'}}"
              />
            </ion-col>
            <ion-col
              size="10"
              (click)="showContent(media.description,media.Content_GUID)"
            >
              <ion-item>
                <ion-label>{{media.description}}</ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <div *ngIf="mediaTypeSelected == 'Upload new media'">
        <ion-grid
          (dragover)="handleDragOver($event)"
          (drop)="handleDrop($event)"
          (click)="addNewQuestion(module,scene)"
        >
          <div class="shadow-box" [ngClass]="{'drag-over': isDragging}">
            <ion-col>
              Drag and drop media files here<br /><br />
              <!-- <ion-button>Add a question</ion-button> or
              <ion-button>Add STS content</ion-button> -->
              <br />
              <br />
              <ion-icon name="cloud-upload-outline" size="large"></ion-icon
              ><br />
            </ion-col>
          </div>
          <ion-row *ngIf="totalFilesUploaded > 0 && totalFilesProcessed > 0">
            <ion-col>
              <ion-item>
                <ion-title>Upload progress</ion-title>
                <ion-progress-bar type="indeterminate"></ion-progress-bar>
              </ion-item>
              <ion-item>
                <ion-title
                  >Total Files remaining : {{totalFilesProcessed}}</ion-title
                >
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <ion-infinite-scroll
        threshold="100px"
        (ionInfinite)="loadMoreData($event)"
      >
        <ion-infinite-scroll-content
          loadingSpinner="bubbles"
          loadingText="Loading more data..."
        >
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>

      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Continue</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
